<!-- ***** Header Area Start ***** -->
 
  <nav class="container navbar navbar-expand-lg fixed-top wow fadeInDown" data-wow-delay="0.5s">
	<div class="container-fluid">
		<a href="/home" class="logo navbar-brand">
			<img src="/assets/images/logo/logo.jpg" alt="Softy Pinko"/>
		</a>
	  <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarTogglerDemo01" aria-controls="navbarTogglerDemo01" aria-expanded="false" aria-label="Toggle navigation">
		<span class="navbar-toggler-icon"></span>
	  </button>
	  <div class="collapse navbar-collapse" id="navbarTogglerDemo01">
		
		<ul class="navbar-nav ms-auto mb-2 mb-lg-0">
			<li class="nav-item">
				<a class="nav-link smooth"aria-current="page" [routerLink]="['/home']" routerLinkActive="active">Home</a>
			</li>
			  
			<li class="nav-item dropdown about-dropdown" aria-haspopup="true"
			data-menu-toggle="hover">
				<a class="nav-link smooth" routerLink="/about"  routerLinkActive="active" [ngClass]="{'active': history.isActive || deployment.isActive || recruitmentProcess.isActive || generalInformation.isActive}" role="button" data-bs-toggle="dropdown" aria-expanded="false">
					About <i class="fa fa-caret-down"></i>
				</a>
				<ul class="dropdown-menu">
					<li><a class="dropdown-item" routerLink="/history" routerLinkActive #history="routerLinkActive" routerLinkActive="active">Company History</a></li>
					<li><a class="dropdown-item" routerLink="/our-deployment" routerLinkActive #deployment="routerLinkActive" routerLinkActive="active">Our Deployment</a></li>
					<li><a class="dropdown-item" routerLink="/recruitment-process" routerLinkActive #recruitmentProcess="routerLinkActive" routerLinkActive="active">Recruitment Process</a></li>
					<li><a class="dropdown-item" routerLink="/general-information" routerLinkActive #generalInformation="routerLinkActive" routerLinkActive="active">General Information</a></li>
				</ul>
			</li>
			
			<li class="nav-item smooth">
				<a class="nav-link smooth" [routerLink]="['/ceo']" routerLinkActive="active">Meet the CEO</a>
			</li>
			<li class="nav-item">
				<a class="nav-link smooth" [routerLink]="['/job']" routerLinkActive="active">Job Listing</a>
			</li>
			<li class="nav-item">
				<a class="nav-link smooth" [routerLink]="['/gallery']" routerLinkActive="active">Gallery</a>
			</li>
			<li class="nav-item">
				<a class="nav-link smooth" [routerLink]="['/contact']" routerLinkActive="active">Contact</a>
			</li>
		</ul>
	  </div>
	</div>
  </nav>
